export * from './Badge.styled';
